// The backend sends timestamps as UTC ISO strings with a trailing "Z"; the browser converts them to the viewer's time zone.
// Date-only fields (LocalDate, e.g. debt entryDate) must NOT go through these helpers — a zone shift could move them a day.

const LOCALE = 'uk-UA';

export const formatDateTime = (value: string): string =>
  new Date(value).toLocaleString(LOCALE, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });

export const formatTimestampDate = (value: string): string =>
  new Date(value).toLocaleDateString(LOCALE, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
